<template>
  <el-table
    ref="table"
    :height="height"
    :data="data"
    :border="border"
    :row-class-name="tableRowClassName"
    :default-sort="sort"
    @selection-change="handleSelectionChange"
    @sort-change="handleSortChange"
  >
    <template v-for="(column, index) in columns">
      <el-table-column
        v-if="column.type"
        :fixed="column.fixed"
        :key="column.label"
        :type="column.type"
        :selectable="column.selectable"
      ></el-table-column>
      <el-table-column
        v-else
        :key="column.label"
        :type="column.type"
        :fixed="column.fixed"
        :prop="column.prop"
        :label="column.label"
        :sortable="column.sortable"
        :width="column.width || ''"
        :min-width="column.minWidth || ''"
        :formatter="column.formatter"
      >
        <template scope="scope">
          <Cell
            v-if="column.render"
            :row="scope.row"
            :column="column"
            :index="index"
            :fixed="column.fixed"
            :render="column.render"
            :scope="scope"
          ></Cell>
          <span v-else-if="column.formatter">
            {{
              column.formatter(
                scope.row,
                column,
                computeProp(scope.row, column.prop),
                scope.row[column.prop]
              )
            }}
          </span>
          <span v-else>{{ computeProp(scope.row, column.prop) }}</span>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
import Cell from "./expand";

export default {
  name: "list-table",
  components: {
    Cell
  },
  data() {
    return {};
  },
  props: {
    border: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    height: {
      type: [String, Number],
      default() {
        return null;
      }
    },
    defaultVal: {
      type: String,
      default: "-"
    },
    tableRowClassName: {
      type: Function,
      default: null
    },
    sort: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    computeProp(row, propsStr = "") {
      let props = propsStr.split(".");
      let current = null;

      for (let [i, k] of props.entries()) {
        try {
          current = (current && current[k]) || row[k];
          if (i === props.length - 1) {
            return current || this.defaultVal;
          }
        } catch (e) {
          throw new Error(e);
        }
      }
    },
    handleSelectionChange(val) {
      this.$emit("selection-change", val);
    },
    handleSortChange({ column, prop, order }) {
      this.$emit("sort-change", { column, prop, order });
      this.$emit("update:sort", { prop, order });
    },
    clearSelection() {
      this.$refs.table.clearSelection();
    }
  }
};
</script>
<style lang="scss">
.el-table .cell:hover {
  -webkit-box-orient: inherit;
}
</style>
